import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import echarts from 'echarts'
import moment from 'moment'//导入文件 js 时间类库 
import getWxUser from './wx'

import WechatPlugin from './WechatPlugin'
// 全局注册微信jsdk
Vue.use(WechatPlugin)

import { Lazyload } from 'vant';
Vue.use(Lazyload);

Vue.filter('dateformat', function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(dataStr).format(pattern)
})

Vue.prototype.$moment = moment;//赋值使用

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
})

Vue.prototype.$echarts = echarts
Vue.config.productionTip = false

//本地测试以及发布需要修改该字段进行切换
var localTest = false;
var appVue;
if (localTest) {
  // 本地测试流程
  appVue = new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
} else {
  //微信公众号流程---获取完用户信息 再执行操作
  getWxUser().then((res) => {
    console.log("get wx user ok......");
    appVue = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  });
}

window.appVue = appVue
export default appVue;
